import { graphql, useFragment } from "react-relay";
import { findFirstNonEmptyString } from "scmp-sdk";

import type { hooksHomeV2StoryPackageTopicQueue$key } from "scmp-app/queries/__generated__/hooksHomeV2StoryPackageTopicQueue.graphql";

type Settings = {
  custom_text?: string;
};

export const useHomeV2StoryPackageTopic = (
  reference?: hooksHomeV2StoryPackageTopicQueue$key | null,
) => {
  const data = useFragment(
    graphql`
      fragment hooksHomeV2StoryPackageTopicQueue on Queue {
        refTerms {
          ... on Newsletter {
            name
            __typename
          }
          ... on Section {
            name
            ...entityLink
            __typename
          }
          ... on Topic {
            name
            ...entityLink
            __typename
          }
        }
        settings
      }
    `,
    reference ?? null,
  );

  const term = data?.refTerms?.[0];
  const customText = (data?.settings as Settings | undefined)?.custom_text;
  const termName = term && term.__typename !== "%other" ? term.name : undefined;
  const name = findFirstNonEmptyString(customText, termName) ?? "";

  return { name, term };
};
